<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>对账</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form
      :inline="true"
      :model="formInline"
      label-position="right"
      label-width="120px"
      class="searchBar"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="票据号码" prop="moneyOrderCode">
            <el-input
              size="small"
              clearable
              v-model="formInline.moneyOrderCode"
              placeholder="票据号码"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="出库开始日期">
            <el-date-picker
              style="width: 190px !important"
              size="small"
              v-model="formInline.startOutDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="出库结束日期">
            <el-date-picker
              style="width: 190px !important"
              size="small"
              v-model="formInline.endOutDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="入库业务员">
            <el-input
                size="small"
                clearable
                v-model="formInline.inSalesman"
                placeholder="入库业务员"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item>
            <el-button
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >搜索</el-button
            >
            <el-button
              size="small"
              type="info"
              icon="el-icon-delete"
              @click="handleReset"
              >清空</el-button
            >
            <el-button
              size="small"
              @click="handleExport"
              v-hasPerm="btn_perm_type.check.export"
              icon="el-icon-top-right"
              >导出</el-button
            >
            <el-button
                size="small"
                v-hasPerm="btn_perm_type.check.add"
                @click="handleEdit()"
                icon="el-icon-plus"
            >新增</el-button
            >

          </el-form-item>
          <el-form-item>
            <el-upload
                class="upload-demo"
                action="/manager/moneyOrder/importStock"
                multiple
                :file-list="fileList"
                :show-file-list = "false"
                :on-success = "handOnUpload"
               >
              <el-button size="small" v-hasPerm="btn_perm_type.check.import" type="primary">导入</el-button>
            </el-upload>

          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      style="
        width: 100%;
        text-align: right;
        margin-bottom: 10px;
        height: 50px;
        line-height: 50px;
        float: left;
      "
    >
      <span style="margin-right: 15px">
        总业务利润（万）<span style="font-weight: bold">{{
          allBusinessProfit
        }}</span>
      </span>
      <span style="margin-right: 15px">
        总资金利润（万）<span style="font-weight: bold">{{
          allCapitalProfit
        }}</span>
      </span>
      <span style="margin-right: 15px">
        总票面金额（万）<span style="font-weight: bold">{{
          faceAllValue
        }}</span>
      </span>
      <span>
        总张数（张）<span style="font-weight: bold">{{ faceCount }}</span>
      </span>
    </div>
    <!--列表-->
    <el-table
      size="small"
      :data="userData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
      :cell-style="handleCellStyle"
    >
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button
            size="mini"
            v-hasPerm="btn_perm_type.check.rollback"
            type="primary"
            @click="handleEdit(scope.row)"
            >扣资</el-button
          >
          <el-button
              size="mini"
              v-hasPerm="btn_perm_type.check.update"
              type="primary"
              @click="handleRollBack(scope.row)"
          >撤回</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="moneyOrderCode"
        label="票号"
        width="120px"
        show-overflow-tooltip
      >
        <template slot-scope="props">
<!--          <el-tooltip-->
<!--            effect="dark"-->
<!--            :content="props.row.moneyOrderCode"-->
<!--            placement="top-start"-->
<!--          >-->
            <span
              >......<span>{{ props.row.moneyOrderCode.slice(-9) }}</span></span
            >
<!--          </el-tooltip>-->
        </template>
      </el-table-column>
       
      <el-table-column
        sortable
        prop="acceptorName"
        label="承兑人"
        width="140px"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column align="center"
        sortable
        prop="isOutLine"
        label="是否线上"
        width="100px"
        :formatter="handleFormatIsOutline"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="createDate"
        label="入库日期"
        width="100px"
        show-overflow-tooltip
        :formatter="handleFormatDate"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="customerName"
        label="入库客户"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="cusTypeName"
        label="入库客户类型"
        width="100px"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="inSalesman"
        label="入库业务员"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="outDate"
        label="出库日期"
        width="100px"
        show-overflow-tooltip
        :formatter="handleFormatDate"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="outCustomerName"
        label="出库客户"
        show-overflow-tooltip
      >
      </el-table-column>
       <el-table-column
        sortable
        prop="outCusTypeName"
        label="出库客户类型"
        width="100px"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="outSalesman"
        label="出库业务员"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="outInterSalesman"
        label="出库中介业务员"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="faceValue"
        label="面额（万）"
        show-overflow-tooltip
      >
        <template slot-scope="props">
          {{
            props.row.outMoneyOrderStatus == 2 
            ? props.row.outCount > 1 ? `${props.row.faceValue} * ${props.row.outCount}张` : props.row.faceValue 
            : props.row.allCount > 1 ? `${props.row.faceValue} * ${props.row.allCount}张` : props.row.faceValue  
          }}
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="inPercentage"
        label="进价（%）"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="deductionPrice"
        label="扣资（%）"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="inFaceValue"
        label="进价票据价值（万）"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="outPercentage"
        label="售价（%）"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="capitalProfit"
        label="资金利润（万）"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="businessProfit"
        label="业务利润（万）"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="inSalesmanCommission"
        label="入库佣金（万）"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="outSalesmanCommission"
        label="出库佣金（万）"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="outInterSalesmanCommission"
        label="出库中介佣金（万）"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="inBidder"
        label="入库报价员"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="inOffer"
        label="报价成本（%）"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
          sortable
          prop="outBidder"
          label="出库报价员"
          show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="differencePrice"
        label="差价（元）"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="type"
        label="票据类型"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="flaw"
        label="瑕疵情况"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination :pager="pager" @pager="handlePager"></Pagination>
    <Payment
      :visible.sync="paymentVisible"
      :editForm="editForm"
      @confirm="handlePayment"
    ></Payment>
    <EditForm
      :title="title"
      :visible.sync="editFormVisible"
      @confirm="handleEditForm"
    ></EditForm>
  </div>
</template>

<script>
import { listCheck, delCheck,rollBack, exportCheck } from "@/api/ticket/check";
import Pagination from "@/components/pagination";
import Payment from "./payment.vue";
import EditForm from "./add-edit";
import { timestampToDate } from "@/utils";
import { BTN_PERMS_TYPE } from "@/utils/permissions";

export default {
  data() {
    return {
      btn_perm_type: BTN_PERMS_TYPE,
      editForm: {
        deductionPrice: null,
      },
      loading: false,
      editFormVisible: false,
      paymentVisible: false,
      title: "",
      formInline: {
        startOutDate: timestampToDate(new Date()),
        endOutDate: timestampToDate(new Date()),
      },
      userData: [],
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 1,
      },
      allBusinessProfit: 0,
      allCapitalProfit: 0,
      faceAllValue: 0,
      faceCount: 0,
      fileList: []
    };
  },
  components: {
    Pagination,
    Payment,
    EditForm,
  },
  created() {
    this.getData();
  },
  methods: {
    handleCellStyle({ row, column, rowIndex, columnIndex }) {
      if (
        [
          "deductionPrice",
          "outPercentage",
          "capitalProfit",
          "businessProfit",
          "isOutLine",
        ].includes(column.property)
      ) {

        if (row.isOutLine === "1") {
          return null;
        }
        return { background: "#b3d8ff" };
      }

      if (
        [
          "acceptorName",
          "moneyOrderCode",
          "moneyOrderCode",
        ].includes(column.property)
      ) {
         if(row.moneyOrderCode.indexOf("-") > -1){
          return { background: "#BBBB44" };
        }
      }
      return null;
    },
    handleFormatIsOutline(row, column, cellValue) {
      if (cellValue === "0") {
        return "线上";
      }

      return "线下";
    },
    handleFormatDate(row, column, cellValue) {
      if (cellValue) {
        return timestampToDate(cellValue);
      }

      return cellValue;
    },
    handleExport() {
      exportCheck(this.formInline)
        .then((data) => {
          let pathData = window.URL.createObjectURL(data);
          // for IE
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              pathData,
              `${timestampToDate(Date.now())}_对账.xls`
            );
          } else {
            let link = document.createElement("a");
            link.href = pathData; // 创建下载的链接
            link.download = `${timestampToDate(Date.now())}_对账.xls`; // 下载后文件名
            link.target = "_blank";
            link.style.display = "none";
            document.body.appendChild(link);
            link.click(); // 点击下载
            document.body.removeChild(link); // 下载完成移除元素
          }
        })
        .catch(this.$message.error);
    },
    getData() {
      this.loading = true;
      listCheck(this.pager.currentPage, this.pager.pageSize, this.formInline)
        .then(
          ({
            allBusinessProfit,
            allCapitalProfit,
            faceAllValue,
            faceCount,
            pages,
          }) => {
            // 总业务利润
            this.allBusinessProfit = allBusinessProfit;
            // 总资金利润
            this.allCapitalProfit = allCapitalProfit;
            // 总票面金额
            this.faceAllValue = faceAllValue;
            // 总张数
            this.faceCount = faceCount;
            let { content, page, size, totalCount } = pages;
            this.userData = content;
            this.pager.currentPage = page;
            this.pager.pageSize = size;
            this.pager.total = totalCount;
          }
        )
        .catch(this.$message.error)
        .finally(() => {
          this.loading = false;
        });
    },
    handlePager(pager) {
      this.pager.currentPage = pager.currentPage;
      this.pager.pageSize = pager.pageSize;
      this.getData();
    },
    handleSearch() {
      this.getData(this.formInline);
    },
    handleReset() {
      this.formInline = {
        startOutDate: timestampToDate(new Date()),
        endOutDate: timestampToDate(new Date()),
      };
      this.getData();
    },
    handOnUpload(res, file){
      console.info(res)
      if(res.code == 0){
        this.$message({
          type: "success",
          message: "操作成功!",
        });
        this.getData();
      }else{
        this.$message({
          type: "success",
          message: "导入失败!-" + res.msg,
        });
      }
    },
    handleRollBack(row){

      console.info(row.moneyOrderCode)
      if(row.moneyOrderCode.indexOf("2021-") > -1){
        this.$message.error("导入数据与手动添加的票据不能撤回！！");
        return
      }

      this.$confirm("确定要撤回吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
            rollBack(row.id)
                .then(() => {
                  this.$message({
                    type: "success",
                    message: "操作成功!",
                  });
                  this.getData();
                })
                .catch(() => {
                  this.$message.error("数据撤回失败，请稍后再试！");
                });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消撤回！",
            });
          });
    },

    handleEdit(row) {
      if (row) {
        if( row.cusType && row.outCusType){
              this.title = "扣资";
              this.editForm = row;
              this.paymentVisible = true;
        }else{
           this.$message.error("客户类型不能为空！");
        }
       

      



      } else {
        this.title = "新增纸票";
        this.editForm = {};
        this.editFormVisible = true;
      }
    },
    handleDelete(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
          delCheck(row.id)
            .then(() => {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              this.getData();
            })
            .catch(() => {
              this.$message.error("数据删除失败，请稍后再试！");
            });
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除！",
          });
        });
    },
    handlePayment() {
      this.$message.success("扣资成功");
      this.getData();
    },
    handleEditForm() {
      this.getData();
    },
  },
};
</script>

<style scoped>
.searchBar {
  margin-top: 20px;
}
.el-input {
  width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/views/ticket/ticket-check/index.vue